export let ExperimentSpecs = /*#__PURE__*/function (ExperimentSpecs) {
  ExperimentSpecs["AnonymousCart"] = "specs.premium.AnonymousCart";
  ExperimentSpecs["AnonymousCartBusinessEmail"] = "specs.premium.AnonymousCartBusinessEmail";
  ExperimentSpecs["RemoveInsightWidget"] = "specs.premium.domains.removeInsightWidget_DOM2-7302";
  ExperimentSpecs["AvailableTldsModal"] = "specs.premium.domains.AvailableTldsModal";
  ExperimentSpecs["ResultsPageExactMatchHeadline"] = "specs.premium.domains.ResultsPageExactMatchHeadline";
  ExperimentSpecs["HarmonyUpgradePaywall"] = "specs.premium.domains.HarmonyUpgradePaywall";
  ExperimentSpecs["DomainsUpgradePaywallBM"] = "specs.premium.domains.DomainsUpgradePaywallBM";
  ExperimentSpecs["ResultsPageOptimizationsBM"] = "resultsPageOptimizationsV1BM";
  ExperimentSpecs["MatchDomainCycleToPremiumCycle"] = "matchDomainCycleToPremiumCycle";
  ExperimentSpecs["MailboxReferralBM"] = "mailboxReferralDomainsBM";
  ExperimentSpecs["WhoisProgressiveLookup"] = "whoisProgressiveLookup";
  ExperimentSpecs["WhoisMobileOptimizations"] = "whoisMobileOptimizations";
  ExperimentSpecs["LoggedInMobileConnect"] = "loggedInMobileConnectAndAssignDomains";
  ExperimentSpecs["BngTldAlternativesFromRecommendations"] = "specsPremiumDomainsBngTldAlternativesFromRecommendations";
  ExperimentSpecs["ResultsLazyPrices"] = "domainsResultsLazyPrices";
  ExperimentSpecs["DomainMobileFlowLoggedInOptimizations"] = "domainMobileFlowLoggedInOptimizations";
  ExperimentSpecs["SplitPageSixtyForty"] = "splitPageSixtyForty";
  ExperimentSpecs["AccountLevelFloatingDomain"] = "accountLevelFloatingDomain";
  ExperimentSpecs["SiteLevelGateOptimizations"] = "siteLevelGateOptimizations";
  ExperimentSpecs["PricingPerceptionFirstYear"] = "domainsPricingPerceptionFirstYear";
  ExperimentSpecs["BmHarmonyTheme"] = "bmHarmonyTheme";
  return ExperimentSpecs;
}({});
export const HARMONY_FLOW_QUERY_PARAM = 'harmonyFlow';
export const TLD_PREFILL_QUERY_PARAM = 'prefillTld';
export const SEARCH_QUERY_PARAMS = ['q', 'query', 'searchText', 'tlds', 'keywords', 'style', 'domainName'];
//# sourceMappingURL=constants.js.map